import { render, staticRenderFns } from "./WorkdriveFeature.vue?vue&type=template&id=9c1543d0&scoped=true&"
import script from "./WorkdriveFeature.vue?vue&type=script&lang=js&"
export * from "./WorkdriveFeature.vue?vue&type=script&lang=js&"
import style0 from "./WorkdriveFeature.vue?vue&type=style&index=0&id=9c1543d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c1543d0",
  null
  
)

export default component.exports